import { useField } from 'formik';
import { FormsGroup } from './FormsGroup';
import { useFormLabel } from './FormsI18nContext';
import { useTranslation } from 'react-i18next';
import { TreeSelect } from 'antd';
import { SelectBlueArrowIcon } from '../CustomIcons';
import { Key } from 'antd/lib/table/interface';

export interface TreeDataType {
  title: string;
  value?: string;
  children?: { title: string; value: string }[];
}

export type FormsSelectProps = {
  name: string;
  label?: React.ReactNode;
  required?: boolean;
  treeData: TreeDataType[];
  showArrow?: boolean;
  showSearch?: boolean;
  disabled?: boolean;
  placeholder?: string;
  suffixIcon?: React.ReactNode;
  allowClear?: boolean;
  onChange?: (value: any) => void;
  maxTagCount?: number | 'responsive';
  treeExpandedKeys: Key[];
  onTreeExpand: (keys: Key[]) => void;
};

export const FormsTreeSelect = ({
  name,
  label: labelOverride,
  required,
  treeData,
  showSearch,
  showArrow = true,
  disabled = false,
  allowClear = true,
  placeholder,
  suffixIcon,
  onChange,
  maxTagCount,
  treeExpandedKeys,
  onTreeExpand,
}: FormsSelectProps) => {
  const { t } = useTranslation();
  const [field, , helpers] = useField(name);
  const label = useFormLabel(name, labelOverride);

  function handleChange(value: string) {
    helpers.setValue(value || null);
    onChange && onChange(value);
  }

  return (
    <FormsGroup label={label} name={name} required={required}>
      <TreeSelect
        showSearch={showSearch}
        showArrow={showArrow}
        value={field.value}
        onChange={handleChange}
        onBlur={field.onBlur}
        placeholder={placeholder ?? t('selectPlaceholder')}
        allowClear={allowClear}
        suffixIcon={suffixIcon ?? <SelectBlueArrowIcon />}
        disabled={disabled}
        treeData={treeData}
        maxTagCount={maxTagCount}
        treeExpandedKeys={treeExpandedKeys}
        onTreeExpand={onTreeExpand}
      />
    </FormsGroup>
  );
};
